module.exports = __webpack_public_path__ + "img/logo.979cab65.svg";